import './dashboard'
import './ppic'
import './report'

$(document).on("click", ".planning-show-summary-btn", function(){
  const parent = $(this).closest("[planning]")
  const sibling = parent.find(".planning-show-detail-btn")

  $(this).removeClass("btn-outline-primary")
  $(this).addClass("btn-primary")

  sibling.removeClass("btn-primary")
  sibling.addClass("btn-outline-primary")

  parent.find(".planning-summary").removeClass("d-none")  
  parent.find(".planning-detail").addClass("d-none")  
})

$(document).on("click", ".planning-show-detail-btn", function(){
  const parent = $(this).closest("[planning]")
  const sibling = parent.find(".planning-show-summary-btn")

  $(this).removeClass("btn-outline-primary")
  $(this).addClass("btn-primary")

  sibling.removeClass("btn-primary")
  sibling.addClass("btn-outline-primary")

  parent.find(".planning-summary").addClass("d-none")  
  parent.find(".planning-detail").removeClass("d-none")  
})